const DEFAULT_DEV_API_BASE = 'http://localhost:3001';

export const API_BASE = (
  process.env.REACT_APP_API_BASE ||
  (process.env.NODE_ENV === 'production' ? '/api' : DEFAULT_DEV_API_BASE)
).replace(/\/$/, '');

export function apiUrl(path) {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE}${cleanPath}`;
}

export async function apiFetch(path, options = {}) {
  const headers = {
    ...(options.body && !(options.body instanceof FormData) ? { 'Content-Type': 'application/json' } : {}),
    ...(options.headers || {}),
  };
  return fetch(apiUrl(path), {
    ...options,
    headers,
    credentials: 'include',
  });
}

export async function apiJson(path, options = {}) {
  const resp = await apiFetch(path, options);
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || `Backend returned ${resp.status}`);
  }
  return data;
}
